import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {mcpUserEntitlementsStateSelector} from './mcp-user-entitlements-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters, ResourceView} from 'src/modules/entitlements/typedef';

export const mcpUserEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    EntitlementsFilters
>('mcpUserEntitlements');

export const mcpUserEntitlementsActions = mcpUserEntitlementsSlice.actions;
const mcpUserEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.userPage.tabs.userEntitlements.mcp.userEntitlements.entitlements.cache;
export const mcpUserEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.userPage.tabs.userEntitlements.mcp.userEntitlements.entitlements;
export const mcpUserEntitlementsResultSelector = getCachedTableResultSelector(
    mcpUserEntitlementsCacheSelector,
    mcpUserEntitlementsStateSelector,
);
